export default __webpack_public_path__ + "static/media/logo.2d27ead7.svg";